<ion-header>
  <ion-toolbar>
    <ion-title> Please Confirm </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="declineFunction()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="confirm-wrapper">
    <p>Are you sure you want to {{ name }}?</p>
    <div class="button-wrapper">
      <button type="button" class="cnt-button" (click)="confirmFunction()">
        <div class="cnt-button-copy">Yes</div>
      </button>
      <button type="button" class="cnt-button" (click)="declineFunction()">
        <div class="cnt-button-copy">No</div>
      </button>
    </div>
  </div>
</ion-content>
